<script setup lang="ts">
  import { PageDecorationImage } from '@/shared/ui/components'

  import { TagsControlForm } from '@/features/tags-control'

  definePage({
    meta: {
      layout: 'baseNew',
      shopManagerRoute: true,
    },
  })

  const { t } = useI18n()

  useHead({
    title: () => t('page_title_tags_control'),
  })
</script>

<template>
  <div class="wide-responsive relative flex h-full flex-col flex-nowrap! overflow-hidden">
    <div class="relative w-full border-b p-6 pt-8">
      <h1 class="heading-md text-heading!">
        {{ $t('navigation_item_tags') }}
      </h1>

      <PageDecorationImage />
    </div>

    <TagsControlForm />
  </div>
</template>
